import $ from 'jquery';
import datepicker from 'js-datepicker';

// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
$(document).ready(function () {
  // ---------------------------------
  // Calendar date
  // Page event/search
  // ---------------------------------
  const datePickerOptions = {
    onShow: (instance) => {
      const width = $('.jsDatePicker').outerWidth(true);
      $(instance.calendarContainer).css({
        'top': 0,
        'left': width
      });
    },
    onHide: (instance) => {
      $(instance.calendarContainer).siblings('.jsDatePicker')[0].classList.remove('active');
    },
    onSelect: (instance, date) => {
      const siblings = $(instance.calendarContainer).siblings('select');
      $(siblings[0]).val(date.getFullYear()).change();
      $(siblings[1]).val(date.getMonth() + 1).change();
      $(siblings[2]).val(date.getDate()).change();
    },
  };

  let startDatePicker, endDatePicker;

  if($('#jsDatePickerStart').length && $('#jsDatePickerEnd')){
    startDatePicker = datepicker('#jsDatePickerStart', {
      id: 1,
      ...datePickerOptions
    });
  
    endDatePicker = datepicker('#jsDatePickerEnd', {
      id: 2,
      ...datePickerOptions
    });
  }

  $('.jsDatePicker').on('click', function (e) {
    e.stopPropagation();
    let picker;
    switch ($(this).attr('id')) {
      case 'jsDatePickerStart': {
        picker = startDatePicker;
        break;
      }
      case 'jsDatePickerEnd': {
        picker = endDatePicker;
        break;
      }
    }
    const isShow = this.classList.contains('active');
    picker[isShow ? 'hide' : 'show']();
    this.classList[isShow ? 'remove' : 'add']('active');
  });

  function renderSelectDate(start_date, end_date) {
    Object.keys(start_date).forEach(function (key) {
      $(`#start_${key}`).val(start_date[key]).change();
      $(`#end_${key}`).val(end_date[key]).change();
    })
  }

  function onQuickChoose(type) {
    let curDate = new Date();
    let curDay = curDate.getDay();
    let start_date = {};
    let end_date = {};
    switch (type) {
      case 'yesterday':
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        start_date['year'] = end_date['year'] = yesterday.getFullYear();
        start_date['month'] = end_date['month'] = yesterday.getMonth() + 1;
        start_date['day'] = end_date['day'] = yesterday.getDate();
        break;
      case 'today':
        start_date['year'] = end_date['year'] = curDate.getFullYear();
        start_date['month'] = end_date['month'] = curDate.getMonth() + 1;
        start_date['day'] = end_date['day'] = curDate.getDate();
        break;
      case 'tomorrow':
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        start_date['year'] = end_date['year'] = tomorrow.getFullYear();
        start_date['month'] = end_date['month'] = (tomorrow.getMonth() + 1);
        start_date['day'] = end_date['day'] = tomorrow.getDate();
        break;
      case 'thisWeek':
        let start_week = new Date();
        start_week.setDate(start_week.getDate() - curDay + 1);
        let end_week = new Date();
        end_week.setDate(end_week.getDate() + (6 - curDay) + 1);
        start_date['year'] = start_week.getFullYear();
        start_date['month'] = start_week.getMonth() + 1;
        start_date['day'] = start_week.getDate();
        end_date['year'] = end_week.getFullYear();
        end_date['month'] = end_week.getMonth() + 1;
        end_date['day'] = end_week.getDate();
        start_date['day'] = start_week.getDate();
        break;
      case 'nextWeek':
        let start_next_week = new Date();
        start_next_week.setDate(start_next_week.getDate() - (curDay) + 8);
        let end_next_week = new Date();
        end_next_week.setDate(end_next_week.getDate() + (6 - curDay) + 8);
        start_date['year'] = start_next_week.getFullYear();
        start_date['month'] = start_next_week.getMonth() + 1;
        start_date['day'] = start_next_week.getDate();
        end_date['year'] = end_next_week.getFullYear();
        end_date['month'] = end_next_week.getMonth() + 1;
        end_date['day'] = end_next_week.getDate();
        break;
    }
    renderSelectDate(start_date, end_date);
  };

  function onClearDate() {
    const start_end_date = {
      year: '',
      month: '',
      day: ''
    }
    renderSelectDate(start_end_date, start_end_date);
  };

  $('.jsChooseCalendar').on('click', function () {
    onQuickChoose(this.dataset.type);
  });

  $('.jsClearDate').on('click', function () {
    onClearDate();
  });
});
